import { render, staticRenderFns } from "./SSO.vue?vue&type=template&id=26b354ee&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/spa/sso/SSO.vue
// module id = 1460
// module chunks = 28